import React from 'react';
import { Link } from 'react-router-dom';
import { Card, Row, Col, Input, Button, Table, Modal,
	message, Alert, Typography, Tag, Tooltip, Pagination,
} from 'antd';
import {
	SearchOutlined, PlusOutlined, FormOutlined, CloseSquareOutlined,
	ExclamationCircleOutlined, RedoOutlined, SettingOutlined,
	CheckCircleFilled, CloseCircleFilled, GiftOutlined,
} from '@ant-design/icons';
import { connect } from 'react-redux';
import { initHandler, ajaxViewHandler, ajaxHandler, setConfig } from '../../store/actions';
import Config from '../../Config';
import { Helmet } from 'react-helmet';
import ErrorAlertModal from '../../components/ErrorAlertModal';

const { Text } = Typography;

const configClass = {
	title: 'Reward Tepat Waktu',
	apiUrl: { data: 'master/api/reward-diskon/' },
	pageUrl: { form: '/admin/pengaturan/reward-tepat-waktu/form/' },
	breadCrumb: [
		<span><SettingOutlined /> Pengaturan</span>,
		'Reward Tepat Waktu',
	],
};

const config = new Config();

class DataRewardDiskon extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			errMsg: '',
			errTitle: '',
			loadingData: false,
			loadingButton: false,
			pagination: { pageSize: 25, current: 1, total: 0 },
			searchText: '',
			dataSource: [],
			isMobile: window.innerWidth <= 768,
		};
		this._searchTimer = null;
	}

	UNSAFE_componentWillMount() { this.props.initHandler(); }

	componentDidMount() {
		this.getData();
		this._handleResize = () => this.setState({ isMobile: window.innerWidth <= 768 });
		window.addEventListener('resize', this._handleResize);
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this._handleResize);
		clearTimeout(this._searchTimer);
	}

	showDeleteConfirm(id) {
		Modal.confirm({
			title: 'Konfirmasi Hapus',
			icon: <ExclamationCircleOutlined />,
			content: 'Yakin ingin menghapus data reward diskon ini?',
			okText: 'Hapus', okType: 'danger', cancelText: 'Batal',
			onOk: () => this.prosesHapus(id),
		});
	}

	prosesHapus(id) {
		message.loading({ content: 'Menghapus...', key: 'toast' });
		this.props.ajaxHandler('delete', configClass.apiUrl.data + id + '/')
			.then(() => {
				this.setState({ loadingButton: false });
				if (this.props.isSuccess) {
					message.success({ content: 'Data berhasil dihapus', duration: 2, key: 'toast' });
					this.getData();
				} else {
					const errTitle = 'Gagal menghapus data';
					message.error({ content: errTitle, duration: 2, key: 'toast' });
					this.setState({ errTitle, errMsg: this.props.responseMsg });
				}
			}).catch(() => {
				this.setState({ loadingButton: false });
				message.error({ content: 'Kesalahan jaringan, coba lagi', duration: 2, key: 'toast' });
			});
	}

	async getData(limit = this.state.pagination.pageSize, offset = 0, search = this.state.searchText) {
		this.setState({ loadingData: true });
		this.props.ajaxViewHandler('get', `${configClass.apiUrl.data}?limit=${limit}&offset=${offset}&search=${search}`)
			.then(() => {
				const data = this.props.responseMsg;
				if (this.props.isSuccess) {
					this.setState(prev => ({
						dataSource: data.results,
						pagination: { ...prev.pagination, total: data.count },
					}));
				} else {
					this.setState({ errTitle: 'Gagal memuat data', errMsg: this.props.responseMsg });
					message.error({ content: 'Gagal memuat data', duration: 2, key: 'toast' });
				}
				this.setState({ loadingData: false });
			}).catch(() => {
				message.error({ content: 'Gagal request data', duration: 2, key: 'toast' });
				this.setState({ loadingData: false });
			});
	}

	handleSearchChange = (e) => {
		const val = e.target.value;
		this.setState({ searchText: val });
		clearTimeout(this._searchTimer);
		this._searchTimer = setTimeout(() => {
			this.setState(prev => ({ pagination: { ...prev.pagination, current: 1 } }));
			this.getData(this.state.pagination.pageSize, 0, val);
		}, 400);
	};

	handleTableChange = (pagination) => {
		this.setState({ pagination: { ...this.state.pagination, pageSize: pagination.pageSize, current: pagination.current } });
		this.getData(pagination.pageSize, (pagination.current - 1) * pagination.pageSize);
	};

	handleMobilePageChange = (page, pageSize) => {
		this.setState(prev => ({ pagination: { ...prev.pagination, current: page, pageSize } }));
		this.getData(pageSize, (page - 1) * pageSize);
	};

	getTableColumns() {
		return [
			{
				title: 'Nama Kategori',
				dataIndex: 'nama',
				key: 'nama',
				render: (v) => <Text strong style={{ fontSize: 13 }}>{v}</Text>,
			},
			{
				title: 'Periode Program',
				align: 'center',
				children: [
					{ title: 'Mulai',  dataIndex: 'tanggal_mulai',   key: 'tanggal_mulai',   width: 100, align: 'center', render: (v) => <Text style={{ fontSize: 12 }}>{v || '-'}</Text> },
					{ title: 'Selesai', dataIndex: 'tanggal_selesai', key: 'tanggal_selesai', width: 100, align: 'center', render: (v) => <Text style={{ fontSize: 12 }}>{v || '-'}</Text> },
				],
			},
			{
				title: 'Rentang Hari Sebelum JT',
				align: 'center',
				children: [
					{ title: 'Mulai',  dataIndex: 'hari_mulai',  key: 'hari_mulai',  width: 80, align: 'center', render: (v) => <Tag style={{ borderRadius: 20, background: '#e6f0fb', borderColor: '#91b4e8', color: '#1e4d8a', fontWeight: 600 }}>{v} hari</Tag> },
					{ title: 'Sampai', dataIndex: 'hari_sampai', key: 'hari_sampai', width: 80, align: 'center', render: (v) => <Tag style={{ borderRadius: 20, background: '#f9f0ff', borderColor: '#d3adf7', color: '#722ed1', fontWeight: 600 }}>{v} hari</Tag> },
				],
			},
			{
				title: 'Diskon (%)',
				dataIndex: 'persentase',
				key: 'persentase',
				width: 100,
				align: 'center',
				render: (v) => <Tag style={{ borderRadius: 20, background: '#f6ffed', borderColor: '#b7eb8f', color: '#389e0d', fontWeight: 700, fontSize: 13 }}>{parseFloat(v || 0).toFixed(0)}%</Tag>,
			},
			{
				title: 'Keterangan',
				dataIndex: 'keterangan',
				key: 'keterangan',
				render: (v) => <Text type="secondary" style={{ fontSize: 12 }}>{v || '-'}</Text>,
			},
			{
				title: 'Status',
				dataIndex: 'is_aktif',
				key: 'is_aktif',
				width: 80,
				align: 'center',
				render: (v) => v
					? <CheckCircleFilled style={{ color: '#52c41a', fontSize: 16 }} />
					: <CloseCircleFilled style={{ color: '#d9d9d9', fontSize: 16 }} />,
			},
			{
				title: 'Aksi',
				key: 'aksi',
				width: 100,
				fixed: 'right',
				align: 'center',
				render: (_, record) => (
					<div style={{ display: 'flex', gap: 6, justifyContent: 'center' }}>
						<Tooltip title="Edit">
							<Link to={configClass.pageUrl.form + record.id}>
								<Button size="small" shape="circle" type="primary" ghost><FormOutlined /></Button>
							</Link>
						</Tooltip>
						<Tooltip title="Hapus">
							<Button size="small" shape="circle" danger onClick={() => this.showDeleteConfirm(record.id)}>
								<CloseSquareOutlined />
							</Button>
						</Tooltip>
					</div>
				),
			},
		];
	}

	renderMobileCard(record) {
		return (
			<Card
				key={record.id}
				style={{ borderRadius: 14, marginBottom: 12, boxShadow: '0 2px 12px rgba(0,0,0,0.07)', border: '1px solid #f0f0f0', overflow: 'hidden' }}
				bodyStyle={{ padding: 0 }}
			>
				<div style={{ background: 'linear-gradient(135deg, #0f284711, #1e4d8a11)', borderBottom: '1px solid #d0dff5', padding: '12px 16px', display: 'flex', alignItems: 'center', gap: 12 }}>
					<div style={{ width: 44, height: 44, borderRadius: 12, flexShrink: 0, background: 'linear-gradient(135deg, #0f2847, #1e4d8a)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
						<GiftOutlined style={{ color: '#fff', fontSize: 20 }} />
					</div>
					<div style={{ flex: 1, minWidth: 0 }}>
						<div style={{ fontWeight: 700, fontSize: 15, color: '#0f2847' }}>{record.nama}</div>
						<div style={{ display: 'flex', gap: 6, marginTop: 4, flexWrap: 'wrap' }}>
							<Tag style={{ borderRadius: 20, fontSize: 11, margin: 0, background: '#f6ffed', borderColor: '#b7eb8f', color: '#389e0d', fontWeight: 700 }}>
								{parseFloat(record.persentase || 0).toFixed(0)}%
							</Tag>
							{record.is_aktif
								? <Tag style={{ borderRadius: 20, fontSize: 11, margin: 0, background: '#f6ffed', borderColor: '#b7eb8f', color: '#389e0d' }}>Aktif</Tag>
								: <Tag style={{ borderRadius: 20, fontSize: 11, margin: 0, background: '#f5f5f5', borderColor: '#d9d9d9', color: '#aaa' }}>Nonaktif</Tag>
							}
						</div>
					</div>
					<div style={{ display: 'flex', gap: 6 }}>
						<Tooltip title="Edit">
							<Link to={configClass.pageUrl.form + record.id}>
								<Button size="middle" shape="circle" type="primary" ghost><FormOutlined /></Button>
							</Link>
						</Tooltip>
						<Tooltip title="Hapus">
							<Button size="middle" shape="circle" danger onClick={() => this.showDeleteConfirm(record.id)}>
								<CloseSquareOutlined />
							</Button>
						</Tooltip>
					</div>
				</div>
				<div style={{ padding: '10px 16px' }}>
					<Text type="secondary" style={{ fontSize: 11 }}>Periode: </Text>
					<Text style={{ fontSize: 12 }}>{record.tanggal_mulai || '-'} s.d. {record.tanggal_selesai || '-'}</Text>
					<div style={{ marginTop: 6, display: 'flex', gap: 6, flexWrap: 'wrap' }}>
						<Tag style={{ borderRadius: 20, fontSize: 11, background: '#e6f0fb', borderColor: '#91b4e8', color: '#1e4d8a', fontWeight: 600 }}>{record.hari_mulai} hari</Tag>
						<Text type="secondary" style={{ fontSize: 11 }}>s.d.</Text>
						<Tag style={{ borderRadius: 20, fontSize: 11, background: '#f9f0ff', borderColor: '#d3adf7', color: '#722ed1', fontWeight: 600 }}>{record.hari_sampai} hari</Tag>
						<Text type="secondary" style={{ fontSize: 11 }}>sebelum JT</Text>
					</div>
				</div>
			</Card>
		);
	}

	render() {
		const { dataSource, loadingData, pagination, errMsg, errTitle, isMobile, searchText } = this.state;

		return (
			<div>
				<Helmet>
					<title>{configClass.title + ' | ' + config.get_site_info().name}</title>
					<style>{`
						.data-reward-wrap .ant-table-thead > tr > th { background: linear-gradient(135deg, #0f284711, #1e4d8a11) !important; font-weight: 700; font-size: 12px; color: #0f2847; border-bottom: 2px solid #d0dff5; }
						.data-reward-wrap .ant-table-tbody > tr > td { padding: 10px 12px; vertical-align: middle; }
						.data-reward-wrap .ant-table-tbody > tr:hover > td { background: #e8f0fb !important; }
						.data-reward-wrap .ant-table-tbody > tr:nth-child(even) > td { background: #fafafa; }
						.data-reward-wrap .ant-table-tbody > tr:nth-child(even):hover > td { background: #e8f0fb !important; }
					`}</style>
				</Helmet>


				<ErrorAlertModal
					visible={errMsg !== ''}
					title={errTitle}
					error={errMsg}
					onClose={() => this.setState({ errMsg: '', errTitle: '' })}
				/>

				<Card
					className="data-reward-wrap"
					style={{ borderRadius: 14, boxShadow: '0 4px 20px rgba(0,0,0,0.07)', overflow: 'hidden' }}
					bodyStyle={{ padding: 0 }}
				>
					{/* Header */}
					<div style={{
						padding: '16px 20px',
						background: 'linear-gradient(135deg, #0f2847, #1e4d8a)',
						display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 10,
					}}>
						<div>
							<div style={{ color: '#fff', fontWeight: 700, fontSize: 17 }}>
								<GiftOutlined style={{ marginRight: 8 }} />{configClass.title}
							</div>
							<div style={{ color: 'rgba(255,255,255,0.7)', fontSize: 12, marginTop: 2 }}>
								Total {pagination.total || 0} data reward{loadingData && ' · Memuat...'}
							</div>
						</div>
						<div style={{ display: 'flex', gap: 8 }}>
							<Tooltip title="Refresh data">
								<Button
									onClick={() => this.setState(prev => ({ searchText: '', pagination: { ...prev.pagination, current: 1 } }), () => this.getData(this.state.pagination.pageSize, 0, ''))}
									icon={<RedoOutlined />}
									style={{ borderRadius: 8, background: 'rgba(255,255,255,0.15)', border: 'none', color: '#fff' }}
								>
									{!isMobile && 'Refresh'}
								</Button>
							</Tooltip>
							<Link to={configClass.pageUrl.form}>
								<Button type="primary" icon={<PlusOutlined />}
									style={{ borderRadius: 8, background: '#fff', color: '#0f2847', border: 'none', fontWeight: 600 }}
								>
									{isMobile ? 'Tambah' : 'Tambah Reward'}
								</Button>
							</Link>
						</div>
					</div>

					{/* Search bar */}
					<div style={{
						padding: '12px 20px', borderBottom: '1px solid #f0f0f0', background: '#fff',
						display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap',
					}}>
						<Text type="secondary" style={{ fontSize: 12 }}>
							{loadingData ? 'Memuat data...' : `Menampilkan ${dataSource.length} dari ${pagination.total || 0} data`}
						</Text>
						<Input
							placeholder="Cari nama kategori reward..."
							allowClear size="middle"
							prefix={<SearchOutlined style={{ color: '#bbb' }} />}
							style={{ borderRadius: 8, maxWidth: 340 }}
							value={searchText}
							onChange={this.handleSearchChange}
							onClear={() => this.setState(prev => ({ searchText: '', pagination: { ...prev.pagination, current: 1 } }), () => this.getData(this.state.pagination.pageSize, 0, ''))}
						/>
					</div>

					{/* Konten */}
					<div style={{ padding: isMobile ? 12 : 0 }}>
						{isMobile ? (
							<div>
								{loadingData ? (
									<div style={{ textAlign: 'center', padding: 40, color: '#aaa' }}>Memuat data...</div>
								) : dataSource.length === 0 ? (
									<div style={{ textAlign: 'center', padding: 40, color: '#aaa' }}>Tidak ada data</div>
								) : (
									dataSource.map(r => this.renderMobileCard(r))
								)}
								{pagination.total > 0 && (
									<div style={{ textAlign: 'center', padding: '12px 0 4px' }}>
										<Pagination current={pagination.current} pageSize={pagination.pageSize} total={pagination.total} onChange={this.handleMobilePageChange} showSizeChanger={false} simple />
									</div>
								)}
							</div>
						) : (
							<Table
								bordered
								columns={this.getTableColumns()}
								dataSource={dataSource}
								loading={loadingData}
								rowKey="id"
								size="middle"
								scroll={{ x: 'max-content' }}
								pagination={{
									current: pagination.current,
									pageSize: pagination.pageSize,
									total: pagination.total,
									showSizeChanger: true,
									pageSizeOptions: ['10', '25', '50', '100'],
									showTotal: (total, range) => `${range[0]}-${range[1]} dari ${total} data`,
								}}
								onChange={this.handleTableChange}
							/>
						)}
					</div>
				</Card>
			</div>
		);
	}
}

const mapStateToProps = (state) => state.configReducers;

export default connect(
	mapStateToProps,
	{ initHandler, setConfig, ajaxViewHandler, ajaxHandler }
)(DataRewardDiskon);
